import React, { useEffect, useState } from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Typography,
  CircularProgress,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { ORG_FETCH_IN_ACTIVE_USERS } from "../../api/org";

// Replace with your actual API endpoints
const INACTIVE_STUDENTS_API = "https://your-api.com/api/inactive-students";
const ACTIVATE_STUDENT_API = "https://your-api.com/api/students"; // /:id/activate

const InactiveStudentsTable = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "success",
  });

  const fetchInactiveStudents = async () => {
    setLoading(true);
    try {
      const response = await axios.get(ORG_FETCH_IN_ACTIVE_USERS);
      console.log(response);
      setStudents(response.data.inactiveUsers || []);
    } catch (error) {
      console.error("Failed to fetch inactive students", error);
      setSnackbar({
        open: true,
        message: "Failed to fetch students",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleActivate = async (id, email) => {
    try {
      await axios.post(ORG_FETCH_IN_ACTIVE_USERS, {
        id,
        email,
        status: "active", // Assuming you're setting status to "active"
      });

      setSnackbar({
        open: true,
        message: "Student activated!",
        type: "success",
      });

      fetchInactiveStudents(); // Refresh the table
    } catch (error) {
      console.error("Activation failed:", error);
      setSnackbar({ open: true, message: "Activation failed", type: "error" });
    }
  };

  useEffect(() => {
    fetchInactiveStudents();
  }, []);

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "name", headerName: "Name", width: 180 },
    { field: "email", headerName: "Email", width: 220 },
    { field: "orgCode", headerName: "Org Code", width: 120 },
    { field: "status", headerName: "Status", width: 120 },
    {
      field: "actions",
      headerName: "Actions",
      width: 160,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          color="primary"
          onClick={() => handleActivate(params.row.id, params.row.email)}
        >
          Activate
        </Button>
      ),
    },
  ];

  const rows = students.map((s, index) => ({
    id: s._id || index,
    name: s.name,
    email: s.email,
    orgCode: s.orgCode,
    status: s.status,
  }));

  return (
    <Box p={3}>
      <Typography variant="h6" mb={2}>
        Inactive Students
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : (
        <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          pageSize={5}
          rowsPerPageOptions={[5, 10, 20]}
          sx={{
            backgroundColor: "#fff",
            borderRadius: 2,
            boxShadow: 2,
          }}
        />
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.type}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default InactiveStudentsTable;
